var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["href"];
import { ElButton } from "element-plus";
import 'element-plus/es/components/button/style/css'

import { ref, useAttrs } from "vue";
import { sleep } from "@/js/lib/helper/sleep";
export default /* @__PURE__ */ _defineComponent(__spreadProps(__spreadValues({}, {
  inheritAttrs: false
}), {
  __name: "IButton",
  props: {
    type: { default: "" },
    nativeType: { default: "button" },
    size: { default: "" },
    href: { default: "" },
    flexible: { type: Boolean },
    center: { type: Boolean }
  },
  setup(__props, { expose: __expose }) {
    const attrs = useAttrs();
    const buttonEl = ref();
    const isShowRipple = ref(false);
    const onMouseDown = () => __async(this, null, function* () {
      isShowRipple.value = true;
      yield sleep(100);
      isShowRipple.value = false;
    });
    __expose({
      focus: () => __async(this, null, function* () {
        yield sleep(100);
        buttonEl.value.ref.focus();
      })
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.$style.wrapper),
        onMousedown: onMouseDown
      }, [
        _ctx.href ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.href,
          class: _normalizeClass(["el-button", _ctx.type && `el-button--${_ctx.type}`, _ctx.size && `el-button--${_ctx.size}`, _ctx.$style.link, _ctx.flexible && _ctx.$style.flexible, _ctx.center && _ctx.$style.center])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_1)) : (_openBlock(), _createBlock(_unref(ElButton), _mergeProps({
          key: 1,
          ref_key: "buttonEl",
          ref: buttonEl,
          type: _ctx.type,
          "native-type": _ctx.nativeType,
          size: _ctx.size,
          class: [_ctx.flexible && _ctx.$style.flexible, _ctx.center && _ctx.$style.center]
        }, _unref(attrs)), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["type", "native-type", "size", "class"])),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.ripple, isShowRipple.value && _ctx.$style.isShowRipple])
        }, null, 2)
      ], 34);
    };
  }
}));
